import avaPic from "@/public/images/artists/ava.png";
import { Artist } from "@/types/types";

export const ava = {
  id: "167",
  name: "Ava",
  image: avaPic,
  description: `Ava's voice is mild, soft, and airy, with a breathy tone. A light vocal fry at the end of phrases adds a hint of texture without becoming raspy. Her smooth pronunciation, with softly articulated consonants and rounded vowels, creates a comforting and intimate atmosphere.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fava-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Ethereal", "Unprocessed", "Indie", "Folk", "Airy", "Falsetto"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "Very high",
      },
      specific: {
        low: 54,
        high: 76,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
